export default [
  {
    link: 'profile',
    label: 'Profile',
  },
  {
    link: 'reset-password',
    label: 'Reset Password',
  },
  // Google + password (components/auth/SignInMethods).
  {
    link: 'sign-in-methods',
    label: 'Sign-in Methods',
  },
  {
    link: 'notifications',
    label: 'Notifications',
  },
  
]
